import getActionTypesConstants from "./getActionTypesConstants"

import * as actions from "./index"

export default getActionTypesConstants(actions)
